declare namespace $ {

	export class $mol_icon_chart_timeline_variant extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=variant.view.tree.d.ts.map